import { defineComponent as l, ref as t } from "vue";
import s from "./td-longtail-vue-components266.js";
const p = /* @__PURE__ */ l({
  __name: "flyout",
  props: {
    customClass: { default: void 0 },
    dataTealiumRel: { default: void 0 },
    headingText: { default: void 0 },
    ariaLabel: { default: void 0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    disableFocusTrap: { type: Boolean },
    closeAutofocus: { type: Boolean },
    success: { type: Boolean },
    error: { type: Boolean },
    warning: { type: Boolean }
  },
  emits: ["onCloseModal"],
  setup(n, { expose: a }) {
    const o = t(null), e = () => o.value?.openDialog();
    return a({
      openDialog: e,
      closeDialog: () => o.value?.closeDialog()
    }), { __sfc: !0, baseDialog: o, openDialog: e, BaseDialog: s };
  }
});
export {
  p as default
};
